















































import { ICustomAttribute, IState } from '@/store/types';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import OrgService from '@/api/org.service';
import { SYNC_ORG } from '@/store/action-types';
import { CUSTOM_ATTRIBUTE_TYPE } from '@/store/shared';

const typeOptions = [
  { label: 'Text', value: CUSTOM_ATTRIBUTE_TYPE.STRING },
  { label: 'Number', value: CUSTOM_ATTRIBUTE_TYPE.NUMBER },
  { label: 'Date', value: CUSTOM_ATTRIBUTE_TYPE.DATE },
  { label: 'Boolean', value: CUSTOM_ATTRIBUTE_TYPE.BOOLEAN },
];

interface IDecoratedAttribute extends ICustomAttribute {
  id?: string;
}

export default Vue.extend({
  name: 'CustomAttributeEditor',
  data() {
    return {
      loading: true,
      customAttributes: [] as IDecoratedAttribute[],
      typeOptions,
    };
  },
  async created() {
    await this.$store.dispatch(SYNC_ORG);
    const state = this.$store.state as IState;
    const customAttributes = state.org?.customAttributes;
    if (customAttributes && customAttributes.length) {
      // copy from state
      this.customAttributes = customAttributes.map((d) => ({ ...d, id: uuidv4() }));
    }
    this.loading = false;
  },
  computed: {
    changesMade(): boolean {
      // compare local customAttributes to state
      const state = this.$store.state as IState;
      const customAttributes = state.org?.customAttributes;
      if (customAttributes && customAttributes.length && customAttributes.length === this.customAttributes.length) {
        return !customAttributes.every(
          (d, i) => d.name === this.customAttributes[i].name && d.label === this.customAttributes[i].label && d.type === this.customAttributes[i].type
        );
      }
      return true;
    },
  },
  methods: {
    addCustomAttribute() {
      this.customAttributes.push({
        id: uuidv4(),
        label: '',
        name: '',
        type: CUSTOM_ATTRIBUTE_TYPE.STRING,
      });
    },
    removeCustomAttribute(attribute: IDecoratedAttribute) {
      this.customAttributes = [...this.customAttributes.filter((d) => attribute.id !== d.id)];
    },
    async save() {
      this.loading = true;
      try {
        this.customAttributes = this.customAttributes.filter((d) => d.label && d.name && d.type);
        // remove local id
        const leanAttributes = this.customAttributes
          .filter((d) => d.label && d.name && d.type)
          .map((d) => ({
            label: d.label,
            name: d.name,
            type: d.type,
          }));
        // save the custom attributes to org
        await OrgService.update(this.$store.state.org._id, { customAttributes: leanAttributes });
        await this.$store.dispatch(SYNC_ORG);
      } catch (e) {
        this.$message.error('Failed to save custom attributes');
      } finally {
        this.loading = false;
      }
    },
  },
});
